export default __webpack_public_path__ + "static/media/verified.43a1db8b.webp";